import { currencyMinorDigits, type Currency } from "../shared/types";

const currencySymbols: Record<string, string> = { CNY: "¥", USD: "$", EUR: "€", GBP: "£", HKD: "HK$", SGD: "S$", MYR: "RM", THB: "฿", PHP: "₱", IDR: "Rp", VND: "₫" };

export function formatMoney(amountMinor: number, currency = "CNY", options: { sign?: boolean; compact?: boolean } = {}): string {
  const digits = currencyMinorDigits[currency as Currency] ?? 2;
  const amount = amountMinor / (10 ** digits);
  if (options.compact && Math.abs(amount) >= 1_000_000) {
    return `${amount < 0 ? "-" : options.sign && amount > 0 ? "+" : ""}${currencySymbols[currency] ?? `${currency} `}${(Math.abs(amount) / 1_000_000).toFixed(2)}m`;
  }
  const formatted = new Intl.NumberFormat("zh-CN", { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Math.abs(amount));
  const prefix = amount < 0 ? "-" : options.sign && amount > 0 ? "+" : "";
  return `${prefix}${currencySymbols[currency] ?? `${currency} `}${formatted}`;
}

export function formatMinorString(amountMinor: string, currency = "CNY", options: { sign?: boolean; compact?: boolean } = {}): string {
  const digits = currencyMinorDigits[currency as Currency] ?? 2;
  const value = BigInt(amountMinor || "0");
  const negative = value < 0n;
  const absolute = negative ? -value : value;
  const factor = 10n ** BigInt(digits);
  if (options.compact && absolute >= factor * 1_000_000n) {
    const scaled = Number(absolute * 100n / (factor * 1_000_000n)) / 100;
    return `${negative ? "-" : options.sign && value > 0n ? "+" : ""}${currencySymbols[currency] ?? `${currency} `}${scaled.toFixed(2)}m`;
  }
  const integer = absolute / factor;
  const fraction = digits ? `.${String(absolute % factor).padStart(digits, "0")}` : "";
  const integerFormatted = new Intl.NumberFormat("zh-CN").format(integer);
  return `${negative ? "-" : options.sign && value > 0n ? "+" : ""}${currencySymbols[currency] ?? `${currency} `}${integerFormatted}${fraction}`;
}

export function formatPercent(value: number | null): string {
  return value === null ? "N/A" : `${value.toFixed(1)}%`;
}

export const statusLabels: Record<string, string> = {
  active: "启用",
  inactive: "停用",
  pending: "待核对",
  matched: "已对平",
  difference: "有差异",
  complete: "完整",
  incomplete: "待补全",
  partially_settled: "部分结算",
  draft: "待分摊",
  allocated: "已分摊"
};

export const channelLabels: Record<string, string> = {
  store_organic: "店铺自然",
  store_ad: "店铺广告",
  creator_organic: "达人自然",
  creator_paid: "达人投流"
};

export const roleLabels: Record<string, string> = {
  admin: "系统管理员",
  finance_maker: "对账录入",
  finance_reviewer: "财务复核",
  operations: "业务查看"
};
